module.exports = "<div class=\"chart-wrapper\">\r\n  <h3 class=\"title\">{{ title }}</h3>\r\n  <div #chart class=\"chart-container\" >\r\n    <canvas *ngIf=\"!this.isMap()\" [attr.id]=\"chartId\" width=\"{{this.width}}\" #canvas></canvas>\r\n    <app-map-chart *ngIf=\"this.isMap()\" [height]=\"this.height\" [width]=\"this.width\"></app-map-chart>\r\n\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/charts/chart/chart.component.html
// module id = ./src/app/components/charts/chart/chart.component.html
// module chunks = main